import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    deleteUser: boolean,
}

interface Variables {
    deleteUserId: string,
}

export const DELETE_USER: TypedDocumentNode<Result, Variables> = gql`
    mutation DeleteUser($deleteUserId: Int!){
        deleteUser(id: $deleteUserId)
    }       
`
